import { render, staticRenderFns } from "./SponsorsDetails.vue?vue&type=template&id=69c328f6&"
import script from "./SponsorsDetails.vue?vue&type=script&lang=js&"
export * from "./SponsorsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports